<template>
  <div class="home-second">
    <h4 class="clof font32 center">报告类型</h4>
    <line-cross></line-cross>
    <p class="describe clof center font22">
      专注于各行业相关领域的数据研究、数据调研、数据分析等各类 研究及报告,并致力为各行业提供研究和咨询及各种数据专业化的报告
    </p>
    <div class="report">
      <div class="economic-situation item">
        <div class="front">
          <p class="title">中国宏观经济形势报告</p>
        </div>
        <div class="end">
          <ul>
            <li v-for="item in macroscopicList"
                :key="item.id" @click="toDetail(6281, item.id)">{{ item.name }}</li>
          </ul>
          <div class="more" @click="toDetail(6281)">查看更多>></div>
        </div>
      </div>
      <div class="economic-growth item">
        <div class="front">
          <p class="title">中国行业经济发展报告</p>
        </div>
        <div class="end">
          <ul>
            <li v-for="item in industryList"
                :key="item.id" @click="toDetail(6282, item.id)">{{ item.name }}</li>
            <!--<li>中国行业经济发展态势</li>-->
            <!--<li>中国与全球房地产市场动态</li>-->
          </ul>
          <div class="more" @click="toDetail(6282)">查看更多>></div>
        </div>
      </div>
      <div class="foreign-situation item">
        <div class="front">
          <p class="title">中国对外形势报告</p>
        </div>
        <div class="end">
          <ul>
            <li v-for="item in foreignList"
                :key="item.id" @click="toDetail(6284, item.id)">{{ item.name }}</li>
            <!--<li>中国对外贸易形势</li>-->
            <!--<li>中国国际收支账户</li>-->
          </ul>
          <div class="more" @click="toDetail(6284)">查看更多>></div>
        </div>
      </div>
      <div class="mobile-internet item">
        <div class="front">
          <p class="title">中国移动互联网系列报告</p>
        </div>
        <div class="end">
          <ul>
            <li v-for="item in mobileInternetList"
                :key="item.id" @click="toDetail(6753, item.id)">{{ item.name }}</li>
          </ul>
          <div class="more" @click="toDetail(6753)">查看更多>></div>
        </div>
      </div>
      <div class="finance item">
        <div class="front">
          <p class="title">中国金融报告</p>
        </div>
        <div class="end">
          <ul>
            <li v-for="item in financialList"
                :key="item.id" @click="toDetail(6283, item.id)">{{ item.name }}</li>
            <!--<li>中国银行业形势</li>-->
            <!--<li>中国金融市场与大宗商品</li>-->
            <!--<li>中国汇率走势</li>-->
            <!--<li>中国资本流动与外储动态</li>-->
          </ul>
          <div class="more" @click="toDetail(6283)">查看更多>></div>
        </div>
      </div>
      <div class="belt-road item">
        <div class="front">
          <p class="title">一带一路国家形势报告</p>
        </div>
        <div class="end">
          <ul>
            <li v-for="item in beltRoadList"
                :key="item.id" @click="toDetail(6285, item.id)">{{ item.name }}</li>
            <!--<li>东盟5国金融形势报告</li>-->
            <!--<li>一带一路国家宏观经济形势与风险监测</li>-->
          </ul>
          <div class="more" @click="toDetail(6285)">查看更多>></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { $dg_getNavListNoTips } from '@/api';
import LineCross from './LineCross';

export default {
  name: 'HomeSecond',
  data() {
    return {
      listLv1Report: [],
      macroscopicList: [],
      mobileInternetList: [],
      industryList: [],
      financialList: [],
      foreignList: [],
      beltRoadList: [],
    };
  },
  methods: {
    async getListLv1Report() {
      const resp = await $dg_getNavListNoTips();
      this.listLv1Report = resp;
      this.macroscopicList = resp.find(v => v.id === 6281).children.slice(0, 5);
      this.mobileInternetList = resp.find(v => v.id === 6753).children.slice(0, 3);
      this.industryList = resp.find(v => v.id === 6282).children.slice(0, 3);
      this.financialList = resp.find(v => v.id === 6283).children.slice(0, 4);
      this.foreignList = resp.find(v => v.id === 6284).children.slice(0, 5);
      this.beltRoadList = resp.find(v => v.id === 6285).children.slice(0, 3);
    },
    toDetail(channelId, leafId) {
      channelId = +channelId;
      const result = this.listLv1Report.find(v => v.id === +channelId);
      if (!result) return;
      if (!leafId && result.children.length) leafId = result.children[0].id;
      this.$router.push({
        name: 'detail',
        query: {
          channelId,
          leafId,
        },
      });
      // window.open(`${window.location.origin}/detail?chnId=${chnId}&leafId=${leafId}`);
    },
  },
  created() {
    this.getListLv1Report();
  },
  components: { LineCross },
};
</script>

<style scoped lang="scss">
.home-second{
  .report{
    height: 500px;
    position: relative;
    &::after{
      content: "";
      display: block;
      clear: both;
    }
    .item{
      position: absolute;
      width: 390px;
      /*cursor: pointer;*/
      &:hover .front{
        /*transition: height 0s;*/
        height: 0;
        overflow: hidden;
      }
      .front{
        /*transition: height .5s;*/
        width: 100%;
        height: 100%;
        position: absolute;
      }
      &:hover .end{
        transition: transform 0.5s;
        transform: rotateY(360deg);
        height: 100%;
        width: 100%;
        position: absolute;
      }
      .end{
        transform: rotateY(180deg);
        position: absolute;
        height: 0;
        overflow: hidden;
        li{
          margin-bottom: 20px;
          &:last-child{
            margin-bottom: 0;
          }
          cursor: pointer;
          &:hover{
            text-decoration: underline;
          }
        }
        .more{
          font-size: 16px;
          position: absolute;
          bottom: 10px;
          left: 50%;
          transform: translateX(-50%);
          color: white;
          cursor: pointer;
          &:hover{
            text-decoration: underline;
          }
        }
      }
      p{
        width: 100%;
        height: 72px;
        line-height: 72px;
        color: white;
        text-align: center;
        font-size: 22px;
        position: absolute;
        bottom: 0;
        left: 0;
      }
      ul{
        width: 340px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
      }
      li{
        list-style: disc;
        color: white;
        margin-left: 20px;
        font-size: 18px;
      }
    }
  }
}
.economic-situation{
  height: 282px;
  left: 0;
  top: 0;
  .front{
    background: url("../../assets/img/report_1.png") 100%;
  }
  &:hover .end{
    background: rgba(246,75,75,0.9);
  }
  p{
    background: rgba(246,75,75,0.7);
  }
}
.economic-growth{
  height: 222px;
  left: 50%;
  top: 0;
  margin-left: -195px;
  .front{
    background: url("../../assets/img/report_2.png") 100%;
  }
  &:hover .end{
    background: rgba(33,167,164,0.9);
  }
  p{
    background: rgba(33,167,164,0.7);
  }
}
.foreign-situation{
  right: 0;
  top: 0;
  height: 282px;
  .front{
    background: url("../../assets/img/report_3.png") 100%;
  }
  &:hover .end{
    background: rgba(25,174,252,0.9);
  }
  p{
    background: rgba(25,174,252,0.7);
  }
}
.mobile-internet{
  height: 203px;
  left: 0;
  bottom: 0;
  .front{
    background: url("../../assets/img/report_4.png") 100%;
  }
  &:hover .end{
    /*background: rgba(250, 151, 72, 0.9);*/
    background: rgba(25,174,252,0.9);
  }
  p{
    /*background: rgba(250, 151, 72, 0.7);*/
    background: rgba(25,174,252,0.7);
  }
}
.finance{
  height: 263px;
  left: 50%;
  bottom: 0;
  margin-left: -195px;
  .front{
    background: url("../../assets/img/report_5.png") 100%;
  }
  &:hover .end{
    background: rgba(239,163,50,0.9);
  }
  p{
    background: rgba(239,163,50,0.7);
  }
}
.belt-road{
  height: 203px;
  right: 0;
  bottom: 0;
  .front{
    background: url("../../assets/img/report_6.png") 100%;
  }
  &:hover .end{
    background: rgba(20,91,106,0.9);
  }
  p{
    background: rgba(20,91,106,0.7);
  }
}
.describe{
  width: 1000px;
  margin: 25px auto 50px;
}
</style>
